import HouseType from '../houseType';
import RoomObject from '../room';
export default class House extends HouseType {
  constructor() {
    super();
    this.id = 'house';
    this.name = "Enebolig";
    this.icon = "mdi-home";

    this.defaultRooms = [
      new RoomObject('Entry'),
      new RoomObject('Livingroom'),
      new RoomObject('Kitchen'),
      new RoomObject('Bathroom'),
      new RoomObject('Bedroom'),
      new RoomObject('Bedroom'),
      new RoomObject('Bedroom'),
      new RoomObject('Outside')
    ];
  }
}